export const TIME_SPANS = {
  DAYS_365_IN_SECONDS: 31536000,
  DAYS_28_IN_SECONDS: 2419200,
  DAYS_7_IN_SECONDS: 604800,
  ONE_DAY_IN_SECONDS: 86400,
  ONE_HOUR_IN_SECONDS: 3600,
  ONE_MINUTE_IN_SECONDS: 60,
};
